import { useReducer } from "react";
import api from "../api/organizations";

const intialState = {
    createdNewPerson: null,
    staff: []
};

function reducer(state, action) {
    switch (action.type) {
        case "CREATE_NEW":
            return {
                ...state,
                createdNewPerson: action.createdNewPerson
            };
        case "GET_STAFF":
            return {
                ...state,
                staff: action.staff
            };
        default:
            return {
                ...state,
                ...action.payload
            };
    }
}

export default function useManageEmployees(update) {
    const [employeeData, dispatch] = useReducer(reducer, intialState);

    function deleteEmployee(orgId, staffId) {
        api.deleteEmployee(orgId, staffId).then(() => {
            update()
        });
    }

    function blockEmployee(personId) {
        api.blockEmployee(personId).then(() => {
            update()
        });
    }

    function updateEmployee(orgId, staffId, data) {
        api.updateEmployee(orgId, staffId, data).then(() => {
            update()
        });
    }

    return {
        employeeData,
        deleteEmployee,
        blockEmployee,
        updateEmployee,
    };
}
